import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth";
import { App } from "./App";
import { ErrorBoundary } from "./ErrorBoundary";
import { ToastProvider } from "./Toast";

// Self-heal stale lazy-chunk references after a redeploy. Pages are code-split
// and dynamically imported; a browser holding an older entry bundle will request
// chunk hashes that no longer exist on the CDN, and the failed import would crash
// into the ErrorBoundary. Vite fires `vite:preloadError` in that case — reload
// once to pull the current index.html + fresh chunks. The 10s window guards
// against reload loops if the asset is genuinely unreachable.
const RELOAD_KEY = "wi:lastChunkReload";
window.addEventListener("vite:preloadError", (e) => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 10_000) return;
  e.preventDefault();
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
